<template>
	<Layout :pageTitle="'Ingresar'" :hideNavbar="true" :hideFooter="true">
		<div class="container">
			<div class="card">
				<div class="card-body">
					<router-link tag="a" to="/">
						<img src="https://cobraticket.uy/logo.svg" alt="" class="logo" />
					</router-link>
					<div class="form-box" v-if="!sended">
						<h3 class="mt-3">{{ $t("title") }}</h3>
						<p class="p-2">{{ $t("subtitle") }}</p>
						<FormulateForm v-model="form" ref="form" class="p-2" @submit="submit">
							<FormulateInput
								:label="$t('email')"
								name="email"
								type="email"
								validation="email"
								class="mb-3"
							/>

							<div class="alert alert-danger p-2" v-if="error">
								{{ $t("errorText", { email: form.email }) }}
							</div>

							<div class="form-group mt-4 mb-4">
								<button class="btn btn-primary btn-block" type="submit" :disabled="loading">
									<span v-if="loading">{{ $t("sending") }}...</span>
									<span v-if="!loading">{{ $t("button") }}</span>
								</button>
							</div>
						</FormulateForm>
					</div>
					<div class="form-box" v-if="sended">
						<h3 class="mt-3">{{ $t("sended") }}</h3>
						<p>{{ $t("sendedText") }}</p>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"

export default {
	name: "PasswordForgot",
	components: {
		Layout
	},
	data() {
		return {
			loading: false,
			sended: false,
			error: false,
			form: {}
		}
	},
	methods: {
		submit() {
			if (!this.loading) {
				this.loading = true
				this.error = false
				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($email: String!) {
								userPasswordForgot(email: $email)
							}
						`,
						variables: {
							email: this.form.email
						}
					})
					.then((data) => {
						console.log(data)
						this.loading = false
						this.sended = true
					})
					.catch(() => {
						this.error = true
						this.loading = false
					})
			}
		}
	},
	i18n: {
		messages: {
			es: {
				title: "¿Olvistaste tu contraseña?",
				subtitle:
					"Ingrese su dirección de correo electrónico y le enviaremos un enlace para reestablecer su contraseña",
				button: "Resetear mi contraseña",
				sended: "Hecho!",
				sending: "Enviando...",
				sendedText:
					"Le hemos enviado un correo electrónico con un enlace para que pueda restablecer su contraseña.",
				errorText: "No existe un usuario con el email: {email}",
				email: "Email"
			},
			en: {
				title: "Forgot your password?",
				subtitle:
					"Please enter your email address and you will receive an email that contains a link to set a new password",
				button: "Reset my password",
				sended: "Done!",
				sending: "Sending...",
				sendedText: "We have sent a link to your email so that you can reset your password.",
				errorText: "No user found for email: {email}",
				email: "Email"
			},
			pt: {
				title: "Esqueceu sua senha?",
				subtitle:
					"Inglês su dirección de correo eletrônico y le enviaremos un enlace para estabelecer una nueva contraseña",
				button: "Resetear mi contraseña",
				sended: "Hecho!",
				sending: "Enviando...",
				sendedText:
					"O hemos enviado un correo eletrônico con un enlace para que pueda restablecer su contraseña.",
				errorText: "Nenhum usuario encontrado para e-mail: {email}",
				email: "Email"
			}
		}
	}
}
</script>

<style scoped lang="scss">
.container {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;

	.card {
		width: 414px;
		text-align: center;
		padding-top: 32px;
		padding-bottom: 32px;

		.card-body {
			width: 100%;
			max-width: 85%;
			padding: 0px;
			margin: auto;

			h3 {
				font-size: 1.4rem;
			}
			.logo {
				width: 200px;
				margin-bottom: 10px;
			}
		}
	}
}
.btn-block {
	width: 100%;
}
</style>
